import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
import { serviceName } from '../base/index.js';
export const veriskEdiServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const VeriskEDIEventSchema = EventBaseSchema.merge(z.object({
    type: veriskEdiServiceEventType(),
}));
